// CategoryStackedBar.tsx

import * as React from 'react';
import { BarChart, Bar, XAxis, YAxis,  CartesianGrid,  Tooltip,  Legend, ResponsiveContainer} from 'recharts';

interface IStackedBarProps {
    data: any[];
    title?: string;
    onBarClick?: (data: any) => void;
}

const COLORS = {
    assigned: '#2f89ea',
    completed: '#f0850a',
    users: '#2bcd20',
    modules: '#dd1010'
};

const CategoryStackedBar: React.FC<IStackedBarProps> = ({ data, title, onBarClick }) => {
    if (!data || data.length === 0) {
        return <div style={{ textAlign: 'center', padding: '50px' }}>No data available</div>;
    }

    const handleBarClick = (barData: any) => {
        if (onBarClick) {
            const payload = barData.payload || barData;
            if (payload) {
                onBarClick(payload);
            }
        }
    };

    return (
        <div className="stacked-bar-wrapper" style={{ width: '100%', height: '450px' }}>
            {title && <h3 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px' }}>{title}</h3>}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
                    barCategoryGap="20%"
                    onClick={(e: any) => {
                        if (e && e.activePayload && e.activePayload.length > 0) {
                            const payload = e.activePayload[0].payload;
                            if (onBarClick) {
                                onBarClick(payload);
                            }
                        }
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                    <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip
                        formatter={(value: any, name: string) => {
                            const labels: Record<string, string> = {
                                assigned: 'Training Assigned',
                                completed: 'Training Completed',
                                users: 'Users',
                                modules: 'Modules'
                            };
                            return [value, labels[name] || name];
                        }}
                    />
                    <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                            paddingTop: '15px',
                            fontSize: '14px',
                            fontWeight: '500',
                            width: '100%',
                            overflow: 'visible'
                        }}
                        iconType="circle"
                        iconSize={14}
                    />

                    <Bar
                        dataKey="assigned"
                        stackId="a"
                        fill={COLORS.assigned}
                        name="Training Assigned"
                        onClick={handleBarClick}
                        cursor="pointer"
                    />
                    <Bar
                        dataKey="completed"
                        stackId="a"
                        fill={COLORS.completed}
                        name="Training Completed"
                        onClick={handleBarClick}
                        cursor="pointer"
                    />
                    <Bar
                        dataKey="users"
                        stackId="a"
                        fill={COLORS.users}
                        name="Users"
                        onClick={handleBarClick}
                        cursor="pointer"
                    />
                    <Bar
                        dataKey="modules"
                        stackId="a"
                        fill={COLORS.modules}
                        name="Modules"
                        onClick={handleBarClick}
                        cursor="pointer"
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CategoryStackedBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/StackedBarChart/index.tsx